import React, { Fragment } from 'react';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import Box from '@mui/material/Box';
import ProductOptionGridItem from './ProductOptionGridItem';
import customImage from 'assets/designOptions/custom.png';
import predesignImage from 'assets/designOptions/predesign.png';
import { customMasterCardDesignHandle, customCardDotGiftCardDesignHandle, customEftposCardDesignHandle, isCustomDesignCardByHandle } from 'components/CardConfigurer/configurerFlags';
import { CGProduct } from 'types/shopify';
import { PRODUCT_HANDLE } from 'utilities/constants';

const useStyles: any = makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        maxWidth: 390,
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
      },
    }),
  { name: 'ProductDesignOptions' },
);

const designOptions = [
  {
    title: 'Choose a design',
    description: 'Choose from hundreds of designs for any occasion',
    imgUrl: predesignImage,
    value: 'predesign',
  },
  {
    title: 'Create Custom',
    description: 'Add your own custom photo to a gift card',
    imgUrl: customImage,
    value: 'custom',
  },
];

const ProductDesignOptions: React.FC<{
  input?: any;
  next?: any;
  form?: any;
  product?: CGProduct;
}> = ({ input, next, form, product }) => {
  const styles = useStyles();
  return (
    <Box sx={{ flexGrow: 1 }}>
      <div className={styles.root}>
        {designOptions.map((ProductOption, index) => (
          <Fragment key={`productDesignOption${index}`}>
            <ProductOptionGridItem
              horizontal
              item={ProductOption}
              showArrow
              // @ts-ignore
              onClick={() => {
                input.onChange(ProductOption.value);
                if (product) {
                  if (ProductOption.value === 'custom') {
                    // If the current product is already a custom design product (direct i.e. product/mastercard-custom)
                    if (isCustomDesignCardByHandle(product.handle)) {
                      // Just use that as the design handle...
                      form.change('cardDesignHandle', product.handle);
                    } else {
                      if (product.handle.includes(PRODUCT_HANDLE.MASTER_CARD)) form.change('cardDesignHandle', customMasterCardDesignHandle);
                      if (product.handle.includes(PRODUCT_HANDLE.EFTPOS)) form.change('cardDesignHandle', customEftposCardDesignHandle);
                      if (product.handle.includes(PRODUCT_HANDLE.CARD_GIFT)) form.change('cardDesignHandle', customCardDotGiftCardDesignHandle);
                    }
                  } else {
                    form.change('cardDesignHandle', null);
                  }
                }
                next();
              }}
            />
          </Fragment>
        ))}
      </div>
    </Box>
  );
};

export default ProductDesignOptions;
